import { Button } from '@mui/material';
import { forwardRef } from 'react';

export const ButtonPrimary = forwardRef(({ children, variant = 'contained', color = 'primary', ...props }, ref) => {
  return (
    <Button
      ref={ref}
      variant={variant}
      color={color}
      {...props}
      sx={{
        ...props.sx,
        fontWeight: 600,
        borderRadius: '14px',
      }}
    >
      {children}
    </Button>
  );
});

ButtonPrimary.displayName = 'ButtonPrimary';
